export const isStringAllLettersOrEmpty = (str: string): boolean => {
  if (!str.length) {
    return true;
  }
  return /^[a-zA-Z\s]+$/.test(str);
};
